const BANKREGNR_ALIASES: Record<string, string> = {
    edb: '9812',
};

export const isEikaDigitalBankBankregnr = (bankregnr: string | null): boolean => {
    if (bankregnr === null) {
        return false;
    }

    const trimmedBankregnr = bankregnr.trim();
    const lowerCaseBankregnr = trimmedBankregnr.toLowerCase();

    return BANKREGNR_ALIASES[lowerCaseBankregnr] !== undefined;
};

export const normalizeBankregnr = (bankregnr: string | null): string | null => {
    if (bankregnr === null) {
        return null;
    }

    const trimmedBankregnr = bankregnr.trim();
    return BANKREGNR_ALIASES[trimmedBankregnr.toLowerCase()] ?? trimmedBankregnr;
};
